import "./SessionsCollapsed.css";
import { Session } from "../../api/sessions";

interface SessionsCollapsedProps {
    sessions: Session[];
    loading: boolean;
    error: string;
    onExpand: (sessionId: string) => void;
    onLoadMore: () => void;
    hasMore: boolean;
    loadingMore: boolean;
}

export function SessionsCollapsed({ sessions, loading, error, onExpand, onLoadMore, hasMore, loadingMore }: SessionsCollapsedProps) {
    const formatDate = (timestamp: number) => {
        return new Date(timestamp).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        });
    };

    if (loading) {
        return <div className="sessions-loading">Loading sessions...</div>;
    }

    if (error) {
        return <div className="sessions-error">{error}</div>;
    }

    if (sessions.length === 0) {
        return <div className="sessions-empty">No sessions found</div>;
    }

    return (
        <>
            <div className="sessions-table-container">
                <table className="sessions-table">
                    <thead>
                        <tr>
                            <th>Conversation ID</th>
                            <th>Created At</th>
                            <th>Session</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions.map((session) => (
                            <tr key={session.sessionId}>
                                <td className="session-id">{session.sessionId.slice(0, 20)}</td>
                                <td>{formatDate(session.createdAt)}</td>
                                <td className="session-preview">{session.preview}</td>
                                <td className="action-cell">
                                    <button className="expand-btn" onClick={() => onExpand(session.sessionId)}>
                                        Expand
                                        <span className="expand-icon">»</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {hasMore && (
                <div className="load-more-container">
                    <button className="load-more-btn" onClick={onLoadMore} disabled={loadingMore}>
                        {loadingMore ? <div className="spinner"></div> : 'Load More'}
                    </button>
                </div>
            )}
        </>
    );
}
